<template>
  <sq-form
      v-if="commonsLoaded"
      ref="form"
      :model="formDada"
      label-width="120px"
      v-loading="loading"

      element-loading-text="pocessing..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
    <q-tabs
        v-model="wTab"
        dense
        align="left"
        :class="themeCtx=='dark'?'text-white  shadow-2':''"
        :breakpoint="0">
      <q-tab
          name="details"
          icon="alarm"/>
      <q-tab
          name="notes"
          icon="mail"/>
      <q-tab
          name="past_log"
          icon="restore"/>

    </q-tabs>
    <div slot="header" style="width:100%;">

      <q-btn flat v-if="ScheduleTrip"
             style="font-weight:bold;float:left"
             @click="routeGo({name: 'tripBookings',params: {tripid: ScheduleTrip.id ,kind:'excrs',bookingid:null}} )">
        <strong> {{ ScheduleTrip.tripName }}</strong><small style="padding-left: 10px"> on {{
          ScheduleTrip.humandate
        }}</small>
      </q-btn>
      <q-space></q-space>
      <sf-button v-if="!value"
                 @click="$emit('done', null)"
                 style="float: right;"
                 type="text"
                 size="small"
                 title="just go back to the booking list">
        <i class="material-icons" style="color: white">clear</i>
      </sf-button>
    </div>

    <s-form-actions
        v-if="formDada.tripType=='EXCRS'"
        v-loading="pocessing"
        slot="actions">
      <sf-button
          slot="left"
          style="float: left;"
          v-if="formDada.invoice"
          :disabled="wTab=='past_log'"
          @click="loadInvoice">
        ΑΠΥ
      </sf-button>

      <sf-button
          slot="left"
          :disabled="wTab=='past_log'"
          confirm="Do you want to unlock this booking?"
          v-if="formDada.locked"
          @click="formDada.locked=false;saveBooking(true)"
          style="float: right;"
          type="warning">
        <i class="material-icons">refresh</i>
      </sf-button>

      <template v-else>
        <sf-button
            slot="left"
            style="float: left;"
            :disabled="wTab=='past_log'"
            type="danger"
            confirm="are you sure?"
            v-if="!formDada.locked"
            @click="removeBooking()">
          <i class="material-icons">delete</i>
        </sf-button>
        <sf-button
            slot="left"
            title="This action will UN-cancel the ticket"
            confirm="This action will UN-cancel the ticket. Are you sure?"
            type="warning"
            v-if="formDada.execStatus=='canceled'"
            style="float: left;"
            :disabled="wTab=='past_log'"
            @click="formDada.execStatus='normal';formDada.status='normal';saveBooking(true)">
          <i class="material-icons">thumb_up</i>
        </sf-button>
        <sf-button
            v-else
            slot="left"
            :disabled="wTab=='past_log'"
            title="This action will CANCEL the ticket"
            confirm="This action will CANCEL the ticket. Are you sure?"
            type="danger"
            style="float: left;"
            @click="formDada.execStatus='canceled';formDada.status='canceled';saveBooking(true)">
          <i class="material-icons">block</i>
        </sf-button>
        <sf-button
            :disabled="wTab=='past_log'"
            slot="left"
            type="warning"
            style="float: left;"
            @click="formDada.locked=true;saveBooking(true)">
          <i class="material-icons">vpn_key</i>
        </sf-button>
        <sf-button
            slot="left"
            id="unlockBtn"
            :confirm="formDada.invoiceinfo=='block_api'?'Do you want to UN-Block API generation':'Do you want to Block API generation'"
            v-if="!formDada.locked"
            @click="$set(formDada,'invoiceinfo',formDada.invoiceinfo=='block_api'?null:'block_api');"
            style="float: right;"
            :title="formDada.invoiceinfo=='block_api'?'UN-Block API generation':'Block API generation'"
            type="warning">
          <fa
              icon="times"
              v-if="formDada.invoiceinfo=='block_api'"></fa>
          <fa icon="receipt"></fa>
        </sf-button>
        <sf-button
            slot="left"
            id="unlockBtn"

            v-if="formDada.file_id"
            @click="$router.push({name:'fileBookings',params:{fileid:formDada.file_id}});"
            style="float: right;"
            title="imported from file"
            type="warning">
          <fa
              title="imported from file"
              icon="file-import"
          ></fa>
          {{ formDada.file_id }}

        </sf-button>
        <sf-button
            :disabled="wTab=='past_log'"
            slot="middle"
            type="success"
            @click="issueVoucher(true)">
          <i
              class="material-icons"
              title="print ticket number">confirmation_number</i>
          <span title="Voucher/Ticket Number">{{ formDada.ticketNum }}</span>
          <el-tag
              type="primary"
              v-if="formDada.invoice&&formDada.invoice.aa">{{ formDada.invoice.aa }}:{{ formDada.invoice.date }}
          </el-tag>
        </sf-button>
        <!-- <el-tag
          type="success"
          slot="middle"
          v-if="formConfiguration.ticketNumber=='auto'"
        ></el-tag>-->
        <sf-button
            type="primary"
            v-if="!value"
            :disabled="wTab=='past_log'"
            @click="saveBooking(true,true)"
            style="float: right;">
          <i class="material-icons">done</i>

          <i class="material-icons smicon">add_box</i>
        </sf-button>
        <sf-button
            type="primary"
            style="float: right;"
            :disabled="wTab=='past_log'"
            @click="saveBooking()"
            size="mini">
          <i class="material-icons">done</i>
        </sf-button>

      </template>
    </s-form-actions>
    <s-form-actions
        v-loading="pocessing"
        v-else>
      <sf-button
          slot="left"
          style="float: left;"
          type="danger"
          :disabled="wTab=='past_log'"
          confirm="are you sure?"
          v-if="!formDada.locked"
          @click="removeBooking()">
        <i class="material-icons">delete</i>
      </sf-button>
      <sf-button
          slot="left"
          :disabled="wTab=='past_log'"
          id="unlockBtn"
          :confirm="formDada.invoiceinfo=='block_api'?'Do you want to UN-Block API generation':'Do you want to Block API generation'"
          v-if="!formDada.locked"
          @click="$set(formDada,'invoiceinfo',formDada.invoiceinfo=='block_api'?null:'block_api');"
          style="float: right;"
          :title="formDada.invoiceinfo=='block_api'?'UN-Block API generation':'Block API generation'"
          type="warning">
        <fa
            icon="times"
            v-if="formDada.invoiceinfo=='block_api'"></fa>
        <fa icon="receipt"></fa>
      </sf-button>
      <sf-button
          type="primary"
          style="float: right;"
          @click="saveBooking()"
          size="mini">
        <i class="material-icons">done</i>
      </sf-button>
      <sf-button
          type="primary"
          @click="saveBooking(true,true)"
          style="float: right;">
        <i class="material-icons">done</i>

        <i class="material-icons smicon">add_box</i>
      </sf-button>
    </s-form-actions>
    <s-form-actions
        v-if="wTab=='past_log'"

    >
      <sf-button
          slot="left"
          @click="loadPast('forward')"
          material="fast_rewind"></sf-button>
      <el-tag slot="middle">{{ pastInfo.pastStep + 1 }}/{{ pastInfo.totalMoves }}</el-tag>
      <el-tag slot="middle" type="primary">{{ pastInfo.user }}</el-tag>
      <el-tag slot="middle" type="success">{{ pastInfo.time }}</el-tag>
      <el-tag slot="middle" type="success">{{ pastInfo.action }}</el-tag>
      <sf-button

          @click="loadPast('back')"
          material="fast_forward"></sf-button>
    </s-form-actions>

    <q-banner v-if="formDada?._warnings&&formDada._warnings!='dismiss'" class="bg-accent text-white"
              inline-actions>
      <span v-for="(warn,idx) in formDada._warnings" :key="idx"> {{ warn }}.</span>
      <template v-slot:action>
        <q-btn color="white" outline rounded label="DISMISS FOR NOW"
               @click="formDada._warnings='dismiss';saveBooking(true)"/>
      </template>
    </q-banner>
    <div v-if="wTab=='details'||wTab=='past_log'">
      <!--      <p>{{formDada.routeSeq}}-=-==-</p>-->
      <s-form-item
          label="Contact Name"
          :sz="24">
        <el-input v-model="formDada.customer"></el-input>
      </s-form-item>

      <s-form-item
          label="Place"
          :sz="10">
        <s-remote-select
            :safeMode="false"
            v-model="formDada.ppid"
            class-model="pup"
            query-prop="q"
            label-prop="name"
            captionField="loc_name"
            prefixField="typename"
            @input="checkTimeMap"
            :extraQueryParams="{noEmptyNames:1}"
            @init-option-data="checkTimeMap"
            :optionsPostParser="addMeetingPointOnLabel"></s-remote-select>
      </s-form-item>
      <s-form-item
          label="Room Num."
          :sz="2"
          pl>
        <el-input v-model="formDada.roomnum"></el-input>
      </s-form-item>
      <s-form-item
          label="Specific Meeting Point"
          :sz="12">
        <s-remote-select
            :safeMode="false"
            v-model="formDada.meetingPointId"
            class-model="pup"
            query-prop="q"
            label-prop="name"
            captionField="loc_name"
            prefixField="typename"

            :extraQueryParams="{noEmptyNames:1}"></s-remote-select>
      </s-form-item>
      <s-form-item
          label="Transfer"
          :sz="3"
          pl>
        <el-checkbox
            v-model="formDada.mean"
            true-label="transfer"
            false-label="notransfer"
            @change="formDada.mean=='notransfer'?formDada.meantype='notransfer':formDada.meantype='shuttle'">Yes

        </el-checkbox>
      </s-form-item>

      <s-form-item
          label="Pickup on"
          :sz="3"
          pl>
        <s-time
            v-model="formDada.bookedTimeMM"
            v-if="formDada.tripType=='EXCRS'"></s-time>
        <s-time
            v-else
            v-model="formDada.finalPickupTime"></s-time>
      </s-form-item>

      <div v-if="formDada.tripType=='EXCRS'">
        <s-form-item
            :sz="18"
            label="Ticket Number"
            v-if="formConfiguration.ticketNumber!='auto'">
          <el-col :span="12">
            <el-input
                clearable
                v-model="formDada.ticketNum"
                xblur="checkTicketInServer"
                @change="checkTicketInServer"
                :disabled="handleHistory!='X'"
                class="fit"></el-input>

          </el-col>
          <el-col :span="8">
            <el-radio-group v-model="handleHistory">
              <el-radio-button label="X"></el-radio-button>
              <el-radio-button label="App"></el-radio-button>
              <el-radio-button label="Online"></el-radio-button>

            </el-radio-group>
          </el-col>
          <el-col
              :span="4"
              v-if="formConfiguration.hasTickets">
            <q-checkbox
                left-label
                v-model="formDada.ticketBookCheck"
                label="Co.Tickets"
                checked-icon="task_alt"
                unchecked-icon="highlight_off"
            />
<!--            <el-checkbox-->
<!--                @change="checkTicket"-->
<!--                v-model="formDada.ticketBookCheck"-->
<!--                class="fit"-->
<!--                label="partners ticket book"-->
<!--                border></el-checkbox>-->
          </el-col>
        </s-form-item>
        <s-form-item
            label="Tour Company"
            :sz="8">

          <s-remote-select
              :disabled="!!userRelCoId"
              v-model="formDada.tourCoId"
              class-model="tourcompany"
              query-prop="q"
              label-prop="coname"
              @change-option-data="$set(formDada,'invoiceinfo',$event&&$event.pr_invoiceKind=='none'?'block_api':null);"></s-remote-select>
        </s-form-item>
        <s-form-item
            label="Distributor(nationality)"
            :sz="8">

          <s-remote-select
              :dark="themeCtx=='dark'"
              style="width: 100%"
              :allowCreate="true"
              :extraQueryParams="{
                    labelField: 'distributor',
                    limit: 0,
                    companyId:formDada.tourCoId,
                    action: 'booking/getoptions',
                    valueField: 'distributor',
                  }"
              v-model="formDada.distributor"
              fetchProcessor="booking/getoptions"
              query-prop="query"
              :multiple="false"
              label-prop="distributor"
              value-prop="distributor"
              :placeholder="'Search for distributor'"></s-remote-select>
        </s-form-item>

        <s-form-item
            label="Rep"
            :sz="8"
            class="pl">
          <div style="display: flex">
            <el-popover
                v-if="noRep&&!formDada.repid"
                placement="top-start"
                title="Please note"
                width="200"


                trigger="hover"
                content="Can't locate rep for this ticket">
              <el-button slot="reference" type="text" style="color: red;width: 20px;font-size: 1.2em;padding: 2px"
                         icon="el-icon-warning-outline"></el-button>
            </el-popover>

            <s-remote-select
                ref="repSelector"
                v-model="formDada.repid"
                class-model="rep"
                query-prop="q"
                @change-option-data="handleRepChange"
                label-prop="name"
                prefixField="coname"
                style="flex-grow: 1"
                :extra-query-params="{companyId:formDada.tourCoId}">
              <template slot-scope="{item}">
                {{ item.name }}
                <el-tag type="info">{{ item.coname }}</el-tag>
              </template>
            </s-remote-select>

          </div>
        </s-form-item>
        <s-form-item label="Pax">
          <el-col
              :md="6"
              :sm="12"
              title="Full price pax">
            <fa
                fixed-width
                size="lg"
                icon="male"
                style="float:left"></fa>
            <el-input-number
                @change="calcTotalCost()"
                v-model="formDada.adults"
                controls-position="right"
                :min="0"></el-input-number>
          </el-col>
          <el-col
              :md="6"
              :sm="12"
              title="Reduced price pax">
            <fa
                fixed-width
                size="lg"
                icon="child"
                style="float:left"></fa>
            <el-input-number
                @change="calcTotalCost()"
                v-model="formDada.children"
                controls-position="right"
                :min="0"></el-input-number>
          </el-col>
          <el-col
              :md="6"
              :sm="12"
              title="Free  pax">
            <fa
                fixed-width
                size="lg"
                icon="creative-commons-nc-eu"
                style="float:left"></fa>
            <el-input-number
                v-model="formDada.freePersons"
                controls-position="right"
                :min="0"></el-input-number>
          </el-col>
          <el-col
              :md="6"
              :sm="12"
              title="Infant pax">
            <fa
                fixed-width
                size="lg"
                icon="baby-carriage"
                style="float:left"></fa>
            <el-input-number
                v-model="formDada.infant"
                controls-position="right"
                :min="0"></el-input-number>
          </el-col>
        </s-form-item>
        <s-form-item
            label="Cost"
            deepcolor>
          <el-col
              :span="8"
              title="Full price cost">
            <fa
                fixed-width
                size="lg"
                icon="male"
                style="float:left"></fa>
            <s-number
                v-model="formDada.tickePriceAdult"
                :controls="false"
                :precision="2"
                :step="0.01"
                @change="calcTotalCost()"></s-number>
            <span class="marked">{{ $theMoney(formDada.tickePriceAdult * formDada.adults) }}&euro;</span>
          </el-col>
          <el-col
              :span="8"
              title="Reduced price cost">
            <fa
                fixed-width
                size="lg"
                icon="child"
                style="float:left"></fa>
            <s-number
                v-model="formDada.ticketPriceKid"
                :controls="false"
                :precision="2"
                :step="0.01"
                @change="calcTotalCost()"></s-number>
            <span class="marked">{{ $theMoney(formDada.ticketPriceKid * formDada.children) }}&euro;</span>
          </el-col>
          <el-col
              :span="8"
              title="Total price cost">
            <fa
                fixed-width
                size="lg"
                icon="cash-register"
                style="float:left"></fa>
            <s-number
                v-model="formDada.bookedPrice"
                :controls="false"
                :precision="2"
                :step="0.01"></s-number>
          </el-col>
        </s-form-item>
      </div>
      <div v-else>
        <s-form-item label="Pax">
          <el-col
              :md="6"
              :sm="12"
              title="Full price pax">
            <fa
                fixed-width
                size="lg"
                icon="male"
                style="float:left"></fa>
            <el-input-number

                v-model="formDada.adults"
                controls-position="right"
                :min="0"></el-input-number>
          </el-col>
          <el-col
              :md="6"
              :sm="12"
              title="Reduced price pax">
            <fa
                fixed-width
                size="lg"
                icon="child"
                style="float:left"></fa>
            <el-input-number

                v-model="formDada.children"
                controls-position="right"
                :min="0"></el-input-number>
          </el-col>
          <el-col
              :md="6"
              :sm="12"
              title="Free  pax">
            <fa
                fixed-width
                size="lg"
                icon="creative-commons-nc-eu"
                style="float:left"></fa>
            <el-input-number
                v-model="formDada.freePersons"
                controls-position="right"
                :min="0"></el-input-number>
          </el-col>
          <el-col
              :md="6"
              :sm="12"
              title="Infant pax">
            <fa
                fixed-width
                size="lg"
                icon="baby-carriage"
                style="float:left"></fa>
            <el-input-number
                v-model="formDada.infant"
                controls-position="right"
                :min="0"></el-input-number>
          </el-col>
        </s-form-item>
        <s-form-item
            label="Referense/Voucher Number"
            :sz="8"
            pl>
          <el-input
              v-model="formDada.reference"
              :placeholder="!formDada.id&&!formDada.reference?'leave it blank for auto':('this is auto referense'+formDada.id)"></el-input>
        </s-form-item>
        <s-form-item
            label="Tour Company"
            :sz="10">
          <s-remote-select
              v-model="formDada.tourCoId"
              class-model="tourcompany"
              query-prop="q"
              label-prop="coname"

              @change="$set(formDada,'repid',null)"></s-remote-select>
        </s-form-item>
        <s-form-item
            label="Distributor"
            :sz="6">
          <el-input v-model="formDada.distributor"></el-input>
        </s-form-item>
      </div>

      <s-form-item
          label="Flight"
          v-if="formDada.tripType=='ARV'||formDada.tripType=='DEP'">
        <!--      <s-form-item-->
        <!--          label="When"-->
        <!--          :sz="12"-->
        <!--          pl >-->
        <!--        <s-dater-->
        <!--            v-model="formDada.tripDateTime"-->
        <!--            displayFormat="dd/MM/yyyy" ></s-dater >-->
        <!--      </s-form-item >-->
        <!--      <el-col :span="12" >-->
        <!--        <s-dater-->
        <!--            v-if="bookingFlight.time"-->
        <!--            v-model="bookingFlight.time"-->
        <!--            exportFormat="DD/MM/YYYY"-->
        <!--            displayFormat="dd/MM/yyyy" ></s-dater >-->
        <!--      </el-col >-->
        <!-- <div>
          <el-radio-group v-model="bookingFlight.tripType" size="small">
            <el-radio-button label="ARV"></el-radio-button>
            <el-radio-button label="DEP"></el-radio-button>
          </el-radio-group>
        </div>-->
        <el-col :span="14">
          <!--          {{bookingFlight}}-->
          <s-remote-select
              v-model="formDada.tripid"
              label-prop="flight"
              value-prop="id"
              class-model="flight"
              xeditOptionComponentIs="schedule-trip-form"
              xnewOptionProps="{time:bookingFlight.time,tripType:'DEP'}"
              prefixField="tripType"
              captionField="timeFormated"
              @init-option-data="setInitialTime"
              @change-option-data="e=>vueSet(e,bookingFlight)"
              :extraQueryParams="{limit:20,tripTypes:bookingFlight.tripType?bookingFlight.tripType:'ARV,DEP'}">
            <!--          <template slot-scope="{item}" >-->
            <!--            {{ item.flight }}!==-->
            <!--            <el-tag type="info" >{{ item.timeFormated }}</el-tag >-->
            <!--          </template >-->
          </s-remote-select>
        </el-col>
        <el-col :span="10">
          <!--        ==={{ formDada.meantype }}-->
          <el-radio-group
              :disabled="formDada.mean=='notransfer'"
              v-model="formDada.meantype"
              toggle-color="primary">
            <el-radio-button
                v-for="(sign,tr_code) in transOptions"
                :key="tr_code"
                :label="tr_code">
              <span v-html="sign"></span>
            </el-radio-button>
          </el-radio-group>
        </el-col>
      </s-form-item>
      <template v-else>
        <s-form-item
            label="Deposit"
            :sz="12"
            deepcolor>
          <el-row>
            <el-col
                :md="16"
                :xs="12">
              <s-number
                  v-model="formDada.bookingFee"
                  controls-position="right"></s-number>
            </el-col>
            <el-col
                :md="6"
                :xs="12">
              <el-radio-group
                  v-model="formDada.bookingFee_paymenttype"
                  size="small">
                <el-radio-button label="cash">
                  <span class="material-icons">pan_tool</span>
                </el-radio-button>
                <el-radio-button label="visa">
                  <span class="material-icons">credit_card</span>
                </el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        </s-form-item>

        <s-form-item
            label="Payment"
            :sz="12"
            deepcolor>
          <el-row>
            <el-col
                :md="16"
                :xs="12">
              <s-number
                  v-model="formDada.bookingPayment"
                  controls-position="right"></s-number>
            </el-col>
            <el-col
                :md="6"
                :xs="12">
              <el-radio-group
                  v-model="formDada.bookingPayment_paymenttype"
                  size="small">
                <el-radio-button label="cash">
                  <span class="material-icons">pan_tool</span>
                </el-radio-button>
                <el-radio-button label="visa">
                  <span class="material-icons">credit_card</span>
                </el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        </s-form-item>


      </template>

    </div>
    <div v-else>
      <s-form-item
          label="Phone Number"
          :sz="12">
        <el-input v-model="formDada.note_phone"></el-input>
      </s-form-item>
      <s-form-item
          label="Email"
          :sz="12">
        <el-input v-model="formDada.note_email"></el-input>
      </s-form-item>
      <s-form-item label="General Notes">
        <el-input v-model="formDada.note_generalNotes"></el-input>
      </s-form-item>
      <s-form-item label="Pax Notes">
        <el-input
            v-model="formDada.note_paxNotes"
            type="textarea"
            autosize
            :rows="2"></el-input>
      </s-form-item>
      <!--      ====={{formDada.note_healthInfo}}-->
      <!--      <s-form-item label="Health Notes">-->
      <!--        <el-input-->
      <!--            v-model="formDada.note_healthNotes"-->
      <!--            type="textarea"-->
      <!--            autosize-->
      <!--            :rows="2"></el-input>-->
      <!--      </s-form-item>-->
      <s-form-item label="Group Details">
        <JsonExplorer :jsonString="formDada.note_healthInfo"></JsonExplorer>
      </s-form-item>
    </div>
    <q-dialog
        v-model="apiDialog"
        v-if="formDada.invoice">
      <q-card style="width:70vw;max-width:1500px">
        <q-card-section class="row items-center q-pb-none">
          <q-space/>
          <q-btn
              flat
              round
              dense
              v-close-popup>
            <i class="material-icons">clear</i>
          </q-btn>
        </q-card-section>

        <q-card-section>
          <s-form v-if="aadeReport===null">

            <s-form-item label="API Number">
              <el-col
                  :sm="8"
                  style="background-color:red">
                <el-input
                    v-model="formDada.invoice.aa"
                    class="fit"></el-input>
              </el-col>
              <el-col
                  :sm="10"
                  style="background-color:red">
                <el-date-picker
                    v-model="formDada.invoice.date"
                    format="dd/MM/yyyy"
                    valueFormat="dd/MM/yyyy"></el-date-picker>
              </el-col>
              <el-col :sm="6">
                <sf-button
                    confirm="Are you sure?"
                    @click="changeInvoice()"
                    style="float: right;"
                    type="warning">Correct
                </sf-button>
              </el-col>

            </s-form-item>
            <el-row>
              <el-col :sm="24">
                <sf-button
                    confirm="Are you sure?"
                    @click="changeInvoice(true)"
                    style="float: right;"
                    type="warning">Cancel Invoice and disconect the booking
                </sf-button>
              </el-col>
            </el-row>
            <el-row>
              <sf-button
                  @click="goPdf('voucher-printer-excrs.html', {
                                                                 bkid:formDada.id,
                                                                 })"
                  type="success">Print Ticket
              </sf-button>
            </el-row>
            <h4>({{ relInvoicedData.aa }})
              <small>TAΥΤ.ΑΑΔΕ:</small>
              {{ relInvoicedData.aade_uid }}
            </h4>
            <el-row v-for="mrk in relInvoicedData.aade_marks">
              <!--              <span v-if="mrk.indexOf('[')>=0||mrk.indexOf('error')>=0" >{{ mrk }}</span >-->
              <el-button @click="checkMark(mrk)">{{ mrk }}</el-button>
            </el-row>
            <el-row v-if="relInvoicedData.refuntInvoice">
              <h4> ({{ relInvoicedData.refuntInvoice.aa }})
                <small>ΠΙΣΤΩΤΙΚΟ.ΑΑΔΕ:</small>
                {{ relInvoicedData.aade_uid }}
                <sf-button
                    @click="goPdf('refund-invoice-printer.html', {
                                                                 bkid:relInvoicedData.timologioId,
                                                                 })"
                    type="success">Print Refund
                </sf-button>
              </h4>
              <el-row v-for="mrk in relInvoicedData.refuntInvoice.aade_marks">
                <!--                <span v-if="mrk.indexOf('[')>=0||mrk.indexOf('error')>=0" >{{ mrk }}</span >-->
                <el-button @click="checkMark(mrk)">{{ mrk }}</el-button>
              </el-row>
            </el-row>
          </s-form>
          <template v-else>
            <el-button @click="aadeReport=null">close</el-button>
            <textarea
                style="width: 100%"
                rows="20">{{aadeReport}}</textarea>
          </template>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="voucherDataReceived">
      <q-card style="width:70vw;max-width:1500px">
        <q-card-section class="row items-center q-pb-none">
          <q-space/>
          <q-btn
              flat
              round
              dense
              v-close-popup>
            <i class="material-icons">clear</i>
          </q-btn>
        </q-card-section>

        <q-card-section>
          <div v-html="voucherData"></div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </sq-form>
</template>

<script>
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import funs_bookings from "~/mixins/funs_bookings";
import SfButton from "../../Form/SfButton";

let notf = null;
export default {
  name: 'BookingForm',
  components: {SfButton},
  mixins: [commons,
    funs_bookings],
  props: {
    value: {default: null}
  },
  async mounted() {
    if (this.value) {
      if (_.isObject(this.value))
        this.formDada = this.value
      await this.loadBooking(this.value);
    }
    // var vm = this;
    // // await this.loadBooking();
    // this.formDada.tourCoId = this.userRelCoId
    //   ? this.userRelCoId
    //   : this.formDada.tourCoId;
    // this.loading = false;
  },
  data() {
    return {
      noRep: false,
      wTab: 'details',
      transOptions: {
        'shuttle': '<i class="material-icons" title="common shuttle">airport_shuttle</i>',
        "private": '<i class="material-icons"  title="private car">directions_car</i>',
        "private minibus": '<i class="material-icons"  title="private shuttle">directions_bus</i>',
        "direct": '<i class="material-icons" title="direct transfer">arrow_forward</i>',
        "notransfer": '<i class="material-icons" title="no transfer">directions_walk</i>'
      },
      // scheduleTripRequest: { with: "TripService" },
      bookingFlight: {},
      aadeReport: null,
      apiDialog: false,
      voucherDataReceived: false,
      loading: true,
      relInvoicedData: {},
      voucherData: null,
      errors: {},
      pastInfo: {pastStep: 0, user: null, action: null, totalMoves: 0, time: null},
      pastSnaps: null,
      pocessing: false,

      // formDada: {},
      planedTime: null,
      selectedFlightId: null,
      arvFlightDate: null,
      depFlightDate: null,
    };
  },
  methods: {
    async loadPast(dir) {
      if (!this.pastSnaps) {
        const {data} = await api.fetchProcessor("actionlog/getlist", {
          classes: 'Booking',
          limit: 0,
          relid: this.formDada.id,

        });
        this.pastInfo.totalMoves = data.results.length
        this.pastSnaps = data.results
        this.pastInfo.pastStep = 0
      }

      this.formDada = this.pastSnaps[this.pastInfo.pastStep].snapsot
      this.pastInfo.time = this.pastSnaps[this.pastInfo.pastStep].time
      this.pastInfo.user = this.pastSnaps[this.pastInfo.pastStep].user
      this.pastInfo.action = this.pastSnaps[this.pastInfo.pastStep].action
      if (dir == 'back' && this.pastInfo.pastStep < this.pastInfo.totalMoves - 1) ++this.pastInfo.pastStep
      if (dir == 'forward' && this.pastInfo.pastStep > 0) --this.pastInfo.pastStep
    },
    setInitialTime(ev) {
      _log_('this.bookingFlight', this.formDada)
      if (this.formDada && this.formDada.id) return
      this.bookingFlight = ev
      if (this.bookingFlight.timeFormated) {
        const prts = this.bookingFlight.timeFormated.split(' ')
        if (prts[1]) this.formDada.finalPickupTime = prts[1]

      }
    },
    async loadInvoice() {

      const data = await api.getObject("timologio/get", {
        timologioId: this.formDada.invoice.timologioId
      });
      this.relInvoicedData = data
      this.apiDialog = !this.apiDialog
      _log_('loadInvoice resp:', data)
    },
    async checkMark(mrk) {
      const {data} = await api.fetchProcessor("timologio/massissue", {
        do: 'check',
        mark: mrk
      });
      if (data.results && data.results.aade)
        this.aadeReport = data.results.aade.this_invoice ? data.results.aade.this_invoice : data.results.aade
      //  this.$alert('<pre>' + data.results.aade + '</pre>', 'AADE', {
      //   dangerouslyUseHTMLString: true
      // });
      _log_('mark resp:', data)
    },
    async changeInvoice(cancel) {
      const out = await api.updateProcessor(
          "timologio/update",
          {timologioId: this.formDada.invoice.timologioId, _forceCancel_bks: cancel}
      );

      _log_("hellloooo timologio", out);
    },
    addMeetingPointOnLabel(i) {
      if (i) {
        if (i.mpname)
          i.name =
              (i.name || '') +
              '<span class="material-icons">forward</span><strong>' +
              i.mpname +
              "</strong>";
        return i;
      }
      //="(i)=>i&&i['mpname']
    },
    async issueVoucher() {
      const newBooking = await this.saveBooking(true);
      const out = await api.updateProcessor(
          "gate/emailonlinebooking",
          newBooking
      );
      this.voucherData = out._ticket;
      this.voucherDataReceived = true;
      _log_("hellloooo", out);
    },
    async checkTimeMap() {
      if (!this.formDada.tripid) return;
      if (this.formDada.locked || this.formDada.status != "normal") return;
      const ppid = this.formDada.ppid;

      if (!ppid) return;
      const vm = this,
          timeData = await api.fetchObject("pup", {
            id: ppid,
            rel_trip_id: this.formDada.tripid,
            meetingPointId: this.formDada.meetingPointId
          });
      if (timeData.meetingpoint && !this.formDada.meetingPointId) this.formDada.meetingPointId = timeData.meetingpoint
      _log_("checkTimeMap.0..", ppid, timeData);
      if (timeData && timeData.trip_time && timeData.trip_time.calcedPPTimeMM) {
        this.planedTime = this.intToTime(timeData.trip_time.calcedPPTimeMM);

        if (
            !this.formDada.bookedTimeMM ||
            this.formDada.bookedTimeMM == "00:00"
        )
          this.formDada.bookedTimeMM = this.planedTime;
        if (
            timeData.trip_time.calcedPPTimeMM != timeData.trip_time.tripTime && //this means that there is no scheduled time for this pp
            this.formDada.bookedTimeMM != this.planedTime
        )
          this.$notify({
            type: "warning",
            position: 'top-left',
            title: "Scheduled time for this P.P. is " + this.planedTime,
            onClick(e) {
              vm.formDada.bookedTimeMM = vm.planedTime;
            },
            duration: 4000,

            // message:
            //   "There is a diferense between the time on this booking and the sceduled time of the pickup.Click here to change it",
          });
      }
    },
    calcTotalCost() {
      const ad = this.formDada.adults * this.formDada.tickePriceAdult,
          ch = this.formDada.children * this.formDada.ticketPriceKid;
      this.formDada.bookedPrice = (isNaN(ch) ? 0 : ch) + (isNaN(ad) ? 0 : ad);
    },//11634
    checkTicket: _.debounce(
        function (e) {
          this.checkTicketInServer();
        },
        950,
        {maxWait: 1200}
    ),
    async checkTicketInServer() {
      this.noRep = false
      _log_("checkTicket ", this.formDada.ticketNum);
      const vm = this;
      if (!this.formDada.ticketNum) return;
      let ticketCheck = await api.fetchProcessor(
          "vue_booking/ticketcheck",
          this.formDada
      );

      if (ticketCheck && ticketCheck.data) {
        if (ticketCheck.data.results.coid) {
          this.$set(this.formDada, "tourCoId", ticketCheck.data.results.coid);
          this.$nextTick(async function () {
            if (ticketCheck.data.results.repId) {

              await this.$refs.repSelector.remoteSearch()
              this.$set(this.formDada, "repid", ticketCheck.data.results.repId);
            }
          });
        }
        // this.formDada.repid = ticketCheck.data.results.repId;
        else if (ticketCheck.data.results.message) {
          if (ticketCheck.data.results.bookingid)
            this.$notify({
              type: "warning",
              position: 'top-left',
              title: ticketCheck.data.results.message,
              onClick(e) {
                vm.$router.push({
                  name: vm.$route.name,
                  params: {bookingid: ticketCheck.data.results.bookingid},
                });

                vm.close();
              },
              duration: 5000,

              message: "Click here to go to the booking",
            });
          else {
            if (ticketCheck.data.results.message?.includes('No rep found for')) {
              this.noRep = true
            } else
              this.$message({
                message: ticketCheck.data.results.message,
                type: "warning",
              });
          }
        }
        // this.formDada.repid = ticketCheck.data.results.repId;
      }
    }
    ,
    handleRepChange(e) {
      _log_("ooo ", e);
      if (!e) return;
      this.formDada.tourCoId = e.companyId;
    }
    ,
    getTheFlight(o) {
    }
    ,
    editFlight() {
      this.routeGo({
        name: "tripeditor",
        params: {
          tripid: this.selectedFlightId ? this.selectedFlightId : "new",
        },
      });
    }
    ,
  },

  watch: {
    wTab(v, vo) {
      if (v == vo) return
      if (v == 'past_log') this.loadPast()
      else this.pastSnaps = null
    },
    "formDada.id"(v, vo) {
      //reset things
      if (v == vo) return
      this.pastSnaps = null
    },
    "formDada.tripid": {
      handler(v, vo) {
        if (v == vo) return
        if (!this.bookingFlight) return;
        if (this.bookingFlight.timeFormated) {
          const prts = this.bookingFlight.timeFormated.split(' ')
          if (prts[1]) this.formDada.finalPickupTime = prts[1]
          _log_('this.bookingFlight', this.bookingFlight)
        }
      }, immediate: true
    },
    "formDada.bookedPrice"(v, vo) {
      this.formDada.bookingPayment =
          this.formDada.bookingPayment && this.formDada.bookingPayment != "0"
              ? this.formDada.bookingPayment
              : 0;
      this.formDada.bookingFee =
          this.formDada.bookingFee && this.formDada.bookingFee != "0"
              ? this.formDada.bookingFee
              : 0;
      if (v && v != vo) {
        _log_(
            "P>>>>>>>",
            this.formDada.id,
            this.formDada.bookingPayment,
            this.formDada.bookingFee,
            parseFloat(v),
            parseFloat(this.formDada.bookingPayment) -
            parseFloat(this.formDada.bookingFee)
        );
        if (
            (!this.formDada.bookingPayment && !this.formDada.bookingFee) ||
            !this.formDada.id ||
            this.formDada.id == "new"
        ) {
          // if (this.formDada.bookingFee) v = v - this.formDada.bookingFee;
          this.$set(this.formDada, "bookingPayment", v);
        } else if (
            parseFloat(v) !=
            parseFloat(this.formDada.bookingPayment) -
            parseFloat(this.formDada.bookingFee)
        ) {
          if (!notf)
            notf = this.$notify.error({
              title: "Danger",
              position: 'top-left',
              message: "Payments are not following the booking",
              duration: 5000,
              onClick: () => {
                if (this.formDada.bookingFee) v = v - this.formDada.bookingFee;
                this.$set(
                    this.formDada,
                    "bookingPayment",
                    this.formDada.bookedPrice
                );
                notf.close();
                notf = null;
              },
            });
          return;
        }
        notf = null;
      }
    },
  },
  computed: {
    handleHistory: {
      get() {
        if (this.formDada.history == 'mobile-app') return 'Mobile App'
        if (this.formDada.history == 'online-booking') return 'Online Booking'
        return 'X'
      },
      set(v) {

        if (v == 'Online Booking') {
          this.formDada.history = 'online-booking'
          return
        }
        if (v == 'Mobile App') {
          this.formDada.history = 'mobile-app'
          return
        }
        this.formDada.history = ''
      }
    },
    userRelCoId() {
      return window.UserProfile ? window.UserProfile.userRelCoId : null;
    },
    colFlights() {
      return [
        {
          prop: "flight",
          label: "flight",
          editable: true,
          width: "180px",
        },
        {
          prop: "time",
          label: "time",
          editable: true,
          width: "180px",

          formatter(val) {
            if (val) return dateHelper.format(val * 1000, "DD/MM/YYYY , HH:mm");
            return "&nbsp;";
          },
        },
        {
          prop: "airport",
          label: "airport",
          editable: true,
          width: "180px",
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          sortable: false,
          viewcomponent: {
            is: "sf-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true,
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="sf-button sf-button--default is-circle"><i class="el-icon-close"></i></button>';
          },
        },
      ];
    },
  },
};
</script>
